<template>
	<DaModalFrame v-model:open="modalIsOpen">
		<ConfirmSend
			v-if="modalType === type.CREATE"
			@close="cancel"
			@submit="sendNotification"
			:name="reportName"
		/>
	</DaModalFrame>
	<div>
		<div class="p-6 md-down:px-4">
			<div class="flex items-center justify-between">
				<div
					class="
						__breadcrumbs
						text-sm text-neutral-500
						font-semibold
						flex-nowrap flex
						items-center
					"
				>
					<router-link
						:to="{
							name: routerName.GROUP_CLASS_PLANS_DETAIL_REPORT_HISTORY,
						}"
					>
						Lịch sử kế hoạch
					</router-link>
					<div class="__breadcrumbs__decorate">
						<DaIcon
							name="das--chevron-down"
							class="transform -rotate-90 h-3 w-3 mx-2"
						/>
					</div>
					<div>Xem {{ $filters.terminology('plan') }} đã dạy</div>
				</div>
				<button
					type="button"
					class="
						button-p
						text-center
						w-fit
						btn--text
						text-neutral-500
						hover:text-neutral-600
					"
					@click="
						$router.push({
							name: routerName.GROUP_CLASS_PLANS_DETAIL_REPORT_HISTORY,
						})
					"
				>
					<svg
						width="16"
						height="16"
						viewBox="0 0 16 16"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						class="mr-2 text-neutral-400"
					>
						<path
							d="M1.5 7.99996L0.719131 7.37526L0.219375 7.99996L0.719131 8.62465L1.5 7.99996ZM7.5 8.99996C8.05228 8.99996 8.5 8.55224 8.5 7.99996C8.5 7.44767 8.05228 6.99996 7.5 6.99996V8.99996ZM3.3858 4.04193L0.719131 7.37526L2.28087 8.62465L4.94754 5.29132L3.3858 4.04193ZM0.719131 8.62465L3.3858 11.958L4.94754 10.7086L2.28087 7.37526L0.719131 8.62465ZM1.5 8.99996H7.5V6.99996H1.5V8.99996Z"
							fill="currentColor"
						/>
						<path
							d="M7.78738 13.3439L8.31032 12.4915L7.78738 13.3439ZM6.97976 12.3905L6.05301 12.7662L6.97976 12.3905ZM14.499 12.5015L15.3875 12.9603L14.499 12.5015ZM12.7525 13.981L12.4461 13.0291L12.7525 13.981ZM14.499 3.49854L15.3875 3.0398L14.499 3.49854ZM13.8333 6.81921V9.18087H15.8333V6.81921H13.8333ZM7.83325 5.42133V5.29122H5.83325V5.42133H7.83325ZM9.58524 12.7782C8.62733 12.6186 8.43551 12.5683 8.31032 12.4915L7.26445 14.1962C7.80406 14.5273 8.47961 14.6216 9.25644 14.751L9.58524 12.7782ZM5.83325 10.7107C5.83325 11.4979 5.81518 12.1795 6.05301 12.7662L7.90651 12.0148C7.85132 11.8787 7.83325 11.6814 7.83325 10.7107H5.83325ZM8.31032 12.4915C8.12826 12.3798 7.98675 12.2128 7.90651 12.0148L6.05301 12.7662C6.29374 13.36 6.71828 13.8612 7.26445 14.1962L8.31032 12.4915ZM13.8333 9.18087C13.8333 10.0882 13.8325 10.7099 13.7946 11.1876C13.7573 11.6573 13.6894 11.8898 13.6104 12.0428L15.3875 12.9603C15.6428 12.4658 15.742 11.929 15.7883 11.3458C15.834 10.7705 15.8333 10.0557 15.8333 9.18087H13.8333ZM9.25644 14.751C10.1198 14.8949 10.8251 15.0132 11.4002 15.0628C11.9832 15.113 12.5291 15.1035 13.0589 14.9329L12.4461 13.0291C12.2822 13.0819 12.0416 13.1107 11.5719 13.0702C11.0943 13.029 10.4806 12.9275 9.58524 12.7782L9.25644 14.751ZM13.6104 12.0428C13.3679 12.5125 12.9493 12.8671 12.4461 13.0291L13.0589 14.9329C14.0653 14.609 14.9025 13.8997 15.3875 12.9603L13.6104 12.0428ZM9.58645 3.22163C10.4814 3.07248 11.0948 2.97099 11.5722 2.92986C12.0416 2.88942 12.2822 2.91819 12.4461 2.97096L13.0589 1.06717C12.5292 0.896646 11.9834 0.887021 11.4005 0.937243C10.8256 0.986778 10.1206 1.10503 9.25766 1.24885L9.58645 3.22163ZM15.8333 6.81921C15.8333 5.9444 15.834 5.22954 15.7883 4.65428C15.742 4.07104 15.6428 3.53429 15.3875 3.0398L13.6104 3.95728C13.6894 4.1103 13.7573 4.34283 13.7946 4.81252C13.8325 5.29019 13.8333 5.91191 13.8333 6.81921H15.8333ZM12.4461 2.97096C12.9493 3.13294 13.3679 3.48755 13.6104 3.95728L15.3875 3.0398C14.9025 2.10035 14.0653 1.39113 13.0589 1.06717L12.4461 2.97096ZM9.25766 1.24885C8.83685 1.31898 8.47124 1.37935 8.17099 1.45102C7.85987 1.52528 7.55473 1.62545 7.26252 1.80503L8.30967 3.50898C8.35038 3.48397 8.42887 3.44565 8.63532 3.39637C8.85265 3.3445 9.13857 3.29628 9.58645 3.22163L9.25766 1.24885ZM7.83325 5.29122C7.83325 4.83715 7.83381 4.5472 7.84925 4.3243C7.86391 4.11256 7.88881 4.02884 7.90679 3.98457L6.05387 3.23179C5.92477 3.54955 5.87613 3.86701 5.85403 4.1861C5.8327 4.49405 5.83325 4.86461 5.83325 5.29122H7.83325ZM7.26252 1.80503C6.71792 2.13971 6.29446 2.63958 6.05387 3.23179L7.90679 3.98457C7.98699 3.78717 8.12814 3.62054 8.30967 3.50898L7.26252 1.80503Z"
							fill="currentColor"
						/>
					</svg>
					Thoát
				</button>
			</div>
			<div class="__goal-management-student-detail__header pt-5">
				<div class="flex justify-between items-center w-full">
					<div class="flex gap-6" v-if="groupClass">
						<UserGroup
							:data="groupClass?.students"
							placement="bottom-start"
							class="mt-2"
						/>
						<div>
							<div class="text-neutral-700 font-bold text-4xl">
								{{ groupClass?.name }}
							</div>
							<div class="uppercase text-green-500 font-semibold">
								{{ groupClass?.students?.length }} học sinh
							</div>
						</div>
					</div>
					<div
						class="
							flex
							md-down:w-full
							justify-start
							md-down:flex-row-reverse
						"
						@click="
							$router.push(
								`/report/monthly-report/group-class/${id}/detail?report_id=${data?.group_monthly_report?.id}&month_start=${data?.group_monthly_report?.month_start}`
							)
						"
					>
						<div>
							<button type="button" class="button-p btn--ghost">
								Xem Báo cáo kế hoạch
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="p-6">
			<div class="p-6 bg-white shadow-sm rounded-2xl mb-10">
				<div>
					<div class="flex items-center justify-between mb-8">
						<div class="font-semibold text-neutral-600">
							{{ data?.name || 'Kế hoạch' }}
						</div>
						<div class="flex items-center">
							<div
								class="font-semibold text-neutral-600 mr-8"
								v-if="data?.applied_at"
							>
								Áp dụng:
								{{ $filters.formatDate(data?.applied_at) }}
							</div>
							<Menu as="div" class="ml-3 relative">
								<div>
									<MenuButton
										class="
											rounded-full
											flex
											text-sm
											focus:outline-none
											focus:ring-2
											focus:ring-offset-2
											focus:ring-indigo-500
										"
									>
										<span class="sr-only"
											>Open user menu</span
										>
										<svg
											width="20"
											height="20"
											viewBox="0 0 20 20"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M11.875 16.25C11.875 17.2855 11.0355 18.125 10 18.125C8.96447 18.125 8.125 17.2855 8.125 16.25C8.125 15.2145 8.96447 14.375 10 14.375C11.0355 14.375 11.875 15.2145 11.875 16.25ZM11.875 10C11.875 11.0355 11.0355 11.875 10 11.875C8.96447 11.875 8.125 11.0355 8.125 10C8.125 8.96447 8.96447 8.125 10 8.125C11.0355 8.125 11.875 8.96447 11.875 10ZM11.875 3.75C11.875 4.78553 11.0355 5.625 10 5.625C8.96447 5.625 8.125 4.78553 8.125 3.75C8.125 2.71447 8.96447 1.875 10 1.875C11.0355 1.875 11.875 2.71447 11.875 3.75Z"
												fill="#94A3B8"
											/>
										</svg>
									</MenuButton>
								</div>
								<transition
									enter-active-class="transition ease-out duration-200"
									enter-from-class="transform opacity-0 scale-95"
									enter-to-class="transform opacity-100 scale-100"
									leave-active-class="transition ease-in duration-75"
									leave-from-class="transform opacity-100 scale-100"
									leave-to-class="transform opacity-0 scale-95"
								>
									<MenuItems
										class="
											origin-top-right
											absolute
											right-0
											mt-2
											w-60
											rounded-md
											py-1
											bg-white
											focus:outline-none
											z-10
											shadow-sm
											border border-yellow-100
										"
									>
										<MenuItem
											v-if="data && !data.sent_at"
											v-slot="{ active }"
											@click="confirmSendOpen"
										>
											<div
												class="
													p-2
													px-4
													bg-white
													z-10
													text-gray-600
													hover:bg-neutral-50
													flex
													items-center
													gap-4
													cursor-pointer
												"
												:class="active ? '' : ''"
											>
												<svg
													width="16"
													height="16"
													viewBox="0 0 16 16"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M13.9759 2.73814L9.31765 15.7438C9.26208 15.8975 9.1162 15.9999 8.95276 16H8.82854C8.67608 16 8.53718 15.9124 8.47141 15.7748L6.63918 11.8926C6.36938 11.3202 6.4738 10.6414 6.90314 10.1766L9.23225 7.62981C9.3752 7.47984 9.3752 7.24403 9.23225 7.09406L8.93723 6.799C8.78728 6.65604 8.55149 6.65604 8.40154 6.799L5.85504 9.12837C5.39031 9.55775 4.71155 9.66219 4.13926 9.39236L0.257408 7.55993C0.107709 7.50356 0.00662856 7.36264 0.00120576 7.20276V7.07853C-0.0125429 6.90383 0.0924328 6.74158 0.257408 6.68254L13.2616 2.0238C13.4014 1.97246 13.5583 2.00564 13.6653 2.10921L13.8672 2.31109C13.9885 2.41709 14.0318 2.58703 13.9759 2.73814Z"
														fill="#94A3B8"
													/>
												</svg>

												<span class="mt-0.5"
													>Gửi tới phụ huynh</span
												>
											</div>
										</MenuItem>
									</MenuItems>
								</transition>
							</Menu>
						</div>
					</div>
				</div>
				<div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6">
					<div
						class="
							p-6
							border
							lg:rounded-l-lg
							md:rounded-tl-lg
							border-neutral-200
							w-full
							md-down:rounded-t md-down:rounded-b-none
						"
					>
						<div
							class="
								text-33
								font-bold
								text-neutral-600
								mb-6
								flex flex-nowrap
								items-center
							"
						>
							<img
								src="@/assets/images/icons/abc.png"
								alt=""
								width="32"
								height="32"
								class="mr-2"
								style="height: 32px"
							/>
							{{ skills_count }}
						</div>
						<div class="flex flex-nowrap items-center">
							<span class="text-neutral-500 text-sm"
								>Tổng số lĩnh vực
							</span>
						</div>
					</div>
					<div
						class="
							p-6
							border border-neutral-200
							w-full
							md:border-l-0
							md-down:border-t-0
						"
					>
						<div
							class="
								text-33
								font-bold
								text-neutral-600
								mb-6
								flex flex-nowrap
								items-center
							"
						>
							<img
								src="@/assets/images/icons/light.png"
								alt=""
								width="32"
								height="32"
								class="mr-2"
								style="height: 32px"
							/>
							{{ goals_count }}
						</div>
						<div class="flex flex-nowrap items-center">
							<span class="text-neutral-500 text-sm"
								>Tổng số mục tiêu</span
							>
						</div>
					</div>
					<div
						class="
							p-6
							border border-neutral-200
							w-full
							md:rounded-tr-lg
							lg:rounded-tr-none
							md:border-l-0
							md-down:border-t-0
						"
					>
						<div
							class="
								text-33
								font-bold
								text-neutral-600
								mb-6
								flex flex-nowrap
								items-center
							"
						>
							<img
								src="@/assets/images/icons/light.png"
								alt=""
								width="32"
								height="32"
								class="mr-2"
								style="height: 32px"
							/>
							{{ continued_goals_count }}
						</div>
						<div class="flex flex-nowrap items-center">
							<span class="text-neutral-500 text-sm"
								>Mục tiêu lặp lại</span
							>
						</div>
					</div>
					<div
						class="
							p-6
							border border-neutral-200
							w-full
							lg:border-l-0
							lg-down:border-t-0
							md:rounded-bl-lg
							lg:rounded-bl-none
						"
					>
						<div
							class="
								text-33
								font-bold
								text-neutral-600
								mb-6
								flex flex-nowrap
								items-center
							"
						>
							<img
								src="@/assets/images/icons/light.png"
								alt=""
								width="32"
								height="32"
								class="mr-2"
								style="height: 32px"
							/>
							{{ new_goals_count }}
						</div>
						<div class="flex flex-nowrap items-center">
							<span class="text-neutral-500 text-sm"
								>Mục tiêu mới</span
							>
						</div>
					</div>
					<div
						class="
							p-6
							border border-neutral-200
							w-full
							md:border-l-0
							lg-down:border-t-0
						"
					>
						<div
							class="
								text-33
								font-bold
								text-neutral-600
								mb-6
								flex flex-nowrap
								items-center
							"
						>
							<img
								src="@/assets/images/icons/light.png"
								alt=""
								width="32"
								height="32"
								class="mr-2"
								style="height: 32px"
							/>
							{{ goals_from_stopped_count }}
						</div>
						<div class="flex flex-nowrap items-center">
							<span class="text-neutral-500 text-sm"
								>Từ MT tạm dừng</span
							>
						</div>
					</div>
					<div
						class="
							p-6
							border
							md:border-l-0
							lg:rounded-r-lg
							md:rounded-br-lg
							border-neutral-200
							w-full
							lg-down:border-t-0
							md-down:rounded-b md-down:rounded-t-none
						"
					>
						<div
							class="
								text-33
								font-bold
								text-neutral-600
								mb-6
								flex flex-nowrap
								items-center
							"
						>
							<img
								src="@/assets/images/icons/light.png"
								alt=""
								width="32"
								height="32"
								class="mr-2"
								style="height: 32px"
							/>
							{{ goals_from_lib_count }}
						</div>
						<div class="flex flex-nowrap items-center">
							<span class="text-neutral-500 text-sm"
								>Từ Ngân hàng MT</span
							>
						</div>
					</div>
				</div>
				<div class="mt-4 flex justify-end items-center text-gray-700">
					<div
						v-if="data && data.sent_at && data.sent_by_staff"
						class="flex gap-2"
					>
						<router-link
							:to="`/record/employee/${data.sent_by_staff?.id}`"
						>
							<div class="flex items-center">
								<div>
									<img
										class="
											shadow-sm
											inline-block
											h-6
											w-6
											rounded-full
										"
										:src="
											data.sent_by_staff?.profile_photo
												?.w200
										"
										alt=""
										v-if="
											data.sent_by_staff?.profile_photo
												?.w200
										"
									/>
									<span
										v-else
										class="
											inline-flex
											items-center
											justify-center
											h-6
											w-6
											rounded-full
										"
										:style="{
											background:
												data.sent_by_staff
													?.profile_photo?.default
													?.color,
										}"
									>
										<span
											class="
												font-medium
												leading-none
												text-white text-xs
											"
											>{{
												data.sent_by_staff
													?.profile_photo?.default
													?.initial
											}}</span
										>
									</span>
								</div>
								<div class="ml-4 text-blue-600 font-semibold">
									{{ data.sent_by_staff.name }}
								</div>
							</div>
						</router-link>
						đã gửi KH tới PH
						<span>{{ $filters.formatDateTime(data.sent_at) }}</span>
					</div>
					<div v-else></div>
				</div>
			</div>
			<div v-if="goals && goals.length > 0">
				<div>
					<div
						class="mb-10"
						v-for="(goal, index) in goals"
						:key="index"
					>
						<div
							class="font-semibold text-lg text-neutral-600 mb-4"
						>
							{{ index + 1 }}. {{ goal.skill.name }} ({{
								goal.goals.length
							}})
						</div>
						<div class="shadow-sm sm:rounded-2xl overflow-hidden">
							<div
								class="
									__record__table
									overflow-x-auto
									scroll-bar
								"
							>
								<div
									class="
										overflow-hidden
										sm:rounded-t-2xl
										w-fit
										min-w-full
									"
								>
									<table
										class="
											min-w-full
											divide-y
											text-neutral-200
										"
									>
										<thead class="bg-neutral-100 h-16">
											<tr>
												<th
													scope="col"
													class="
														px-6
														py-3
														text-left text-xs
														font-semibold
														text-neutral-600
														uppercase
														tracking-wider
														w-16
														whitespace-nowrap
													"
												>
													STT
												</th>
												<th
													scope="col"
													class="
														px-6
														py-3
														text-left text-xs
														font-semibold
														text-neutral-600
														uppercase
														tracking-wider
														whitespace-nowrap
													"
													style="min-width: 160px"
												>
													Nội dung
												</th>
											</tr>
										</thead>
										<tbody>
											<tr
												v-for="(g, i) in goal.goals"
												:key="g.id"
												:class="
													i % 2 === 0
														? 'bg-white'
														: 'bg-neutral-50'
												"
												class="text-neutral-700"
											>
												<td
													class="
														px-6
														py-4
														whitespace-nowrap
														text-neutral-700
													"
												>
													<div class="ml-2">
														{{ i + 1 }}
													</div>
												</td>
												<td
													class="
														px-6
														py-4
														text-neutral-700
													"
												>
													<div
														class="
															flex
															items-center
														"
													>
														<router-link
															:to="`/group-class/${id}/${
																g.goal_id ||
																g.id
															}`"
														>
															<div
																class="
																	mr-2
																	hover:text-yellow-700
																	hover:underline
																"
																v-html="g?.name"
															></div>
														</router-link>
														<TooltipGoalDetail
															:goal-id="
																g.goal_id ||
																g.id
															"
															:student-id="id"
														/>
													</div>
													<div
														class="
															flex
															gap-2
															flex-wrap
														"
														style="max-width: 360px"
													>
														<div
															class="
																mt-1
																py-0.5
																px-2.5
																rounded-full
																bg-neutral-200
																text-neutral-700
																h-fit
																w-fit
																whitespace-nowrap
																font-semibold
																shadow-input
															"
															style="
																font-size: 10px;
															"
															v-if="g?.display_source"
														>
															{{
																g?.display_source
															}}
														</div>
														<template
															v-if="
																g?.assistance_levels &&
																org.enable_goal_assistance_level
															"
														>
															<div
																v-for="ass in g?.assistance_levels"
																:key="ass"
																class="
																	flex
																	gap-2
																"
															>
																<div
																	class="
																		mt-1
																		py-0.5
																		px-2.5
																		rounded-full
																		bg-pink-100
																		whitespace-nowrap
																		text-neutral-700
																		h-fit
																		w-fit
																		font-semibold
																		shadow-input
																	"
																	style="
																		font-size: 10px;
																	"
																>
																	{{ ass }}
																</div>
															</div>
														</template>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { computed, defineComponent, ref } from 'vue';
import { useRoute } from 'vue-router';
import { _ROUTER_NAME } from '@/enums';
import DaIcon from '@/components/elements/daIcon/DaIcon';
import { $api } from '@/services';
import { useStore } from 'vuex';
import TooltipGoalDetail from '@/components/elements/tooltipGoalDetail/TooltipGoalDetail';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue';
import DownloadCSV from '@/mixins/downloadCSV';
import UserGroup from '@/components/elements/UserGroup.vue';
import { ACTIONS } from '@/enums/Common';
import ConfirmSend from '@/views/groupClassPlanDetail/confirmSend/ConfirmSend.vue';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame.vue';

export default defineComponent({
	name: 'PlanInHistory',
	components: {
		DaModalFrame,
		ConfirmSend,
		UserGroup,
		TooltipGoalDetail,
		DaIcon,
		Menu,
		MenuItem,
		MenuItems,
		MenuButton,
	},
	setup() {
		const id = computed(() => String(route.params.id || ''));
		const planId = computed(() => String(route.params.planId || ''));
		const route = useRoute();
		const groupClass = ref(null);
		const store = useStore();
		const data = ref(null);
		const goals = ref([]);
		const modalIsOpen = ref(false);
		const modalType = ref('');

		//
		const goals_count = ref(0);
		const skills_count = ref(0);
		const continued_goals_count = ref(0);
		const goals_from_lib_count = ref(0);
		const goals_from_stopped_count = ref(0);
		const new_goals_count = ref(0);

		async function fetchGroupClassDetail() {
			try {
				const {
					data: { data },
				} = await $api.groupClasses.detail(id.value);
				groupClass.value = data;
			} catch (e) {
				console.log(e);
			}
		}

		async function planOfGroupClass() {
			try {
				const {
					data: { data: data_report, stats, skills },
				} = await $api.groupClasses.planOfGroupClass(
					id.value,
					planId.value
				);
				data.value = data_report;
				if (skills) {
					goals.value = skills;
				}
				if (stats) {
					goals_count.value = stats.goals_count;
					skills_count.value = stats.skills_count;
					continued_goals_count.value = stats.continued_goals_count;
					goals_from_lib_count.value = stats.goals_from_lib_count;
					goals_from_stopped_count.value =
						stats.goals_from_stopped_count;
					new_goals_count.value = stats.new_goals_count;
				}
			} catch (e) {
				console.log(e);
			}
		}

		function cancel() {
			modalIsOpen.value = false;
			modalType.value = '';
		}

		const type = computed(() => ACTIONS);
		const reportName = ref('');

		function confirmSendOpen() {
			modalIsOpen.value = true;
			reportName.value = data.value?.order || '';
			modalType.value = type.value.CREATE;
		}

		async function sendNotification() {
			try {
				await $api.groupClasses.sendReport(id.value, data.value?.id);
				cancel();
				await planOfGroupClass();
				await store.dispatch('setAlertMessage', {
					message: 'Gửi kế hoạch đến phụ huynh thành công',
				});
			} catch (err) {
				await store.dispatch('setAlertMessage', {
					message:
						err?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			}
		}
		planOfGroupClass();
		fetchGroupClassDetail();

		return {
			id,
			groupClass,
			data,
			goals_count,
			skills_count,
			continued_goals_count,
			goals_from_lib_count,
			goals_from_stopped_count,
			new_goals_count,
			reportName,
			goals,
			routerName: computed(() => _ROUTER_NAME),
			org: computed(() => store.state.profile.current_org),
			modalIsOpen,
			modalType,
			type,
			cancel,
			confirmSendOpen,
			sendNotification,
		};
	},

	mixins: [DownloadCSV],
});
</script>
